import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { TaxApiModelStub } from '../api-models/stubs/TaxApiModel.stub'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mockGetTaxesSuccess = (
  taxStubs: TaxApiModel[] = [TaxApiModelStub.build()]
) => {
  return http.get(
    `/api/v3/tax/`,
    () => {
      return HttpResponse.json(getResponseObject(taxStubs), { status: 200 })
    },
    { once: true }
  )
}

export const mockGetTaxesError = () => {
  return http.get(
    `/api/v3/tax/`,
    () => {
      return new HttpResponse(null, { status: 400 })
    },
    { once: true }
  )
}

/**
 * Persistent handler that honors the `is_active` query param so a single
 * registration serves both the Active and Inactive tabs (and survives
 * post-command list invalidation refetches).
 */
export const mockGetTaxesSuccessByActiveState = (
  taxStubs: TaxApiModel[] = [TaxApiModelStub.build()]
) => {
  return http.get(`/api/v3/tax/`, ({ request }) => {
    const isActive =
      new URL(request.url).searchParams.get('is_active')?.toLowerCase() !==
      'false'
    const pageSize = Number(
      new URL(request.url).searchParams.get('page_size') || 10
    )

    const data = taxStubs.filter((stub) => stub.is_active === isActive)

    return HttpResponse.json(
      getResponseObject(data, {
        count: data.length,
        page_size: pageSize,
        num_pages: Math.max(1, Math.ceil(data.length / pageSize)),
      }),
      { status: 200 }
    )
  })
}
